import React, {useState, useEffect} from 'react';
import ShowAScreen from './ScreenComponents/ShowAScreen';
import * as CoreFns from './utilities/CoreFns';
import * as InteractionFns from './InteractionFns';
import { useAccount, useNetwork } from 'wagmi'
import {
  useConnectModal,
  useChainModal
} from '@rainbow-me/rainbowkit';
import { disconnect } from '@wagmi/core'

function App(props) {

  var currentList = props.currentList;
  var setAppInfo = props.setAppInfo;
  var width = props.width;
  var overallWidth = props.overallWidth;
  var height = props.height;
  var appInfo = props.appInfo;
  var startFE = CoreFns.getStartFE(currentList);
  var overlays = props.overlays;
  var programSetID = props.programSetID;
  var ownVariables = props.ownVariables;
  var setOwnVariables = props.setOwnVariables;
  var musicStatus = props.musicStatus;
  var setMusicStatus = props.setMusicStatus;
  var run = props.run;
  var offsetLeft = props.offsetLeft;
  var offsetTop = props.offsetTop;
  var publicClient = props.publicClient;
  var chains = props.chains;
  var urlHeader = props.urlHeader;

  const [chainInfo, setChainInfo] = useState({});
  const [otherInfo, setOtherInfo] = useState({});
  const [currentPreviewFE, setPreviewFE] = useState(startFE);
  const [screenRefs, setScreenRefs] = useState({});
  const [popUps, setPopUps] = useState([]);
  // const [toggleView, setToggleView] = useState(0);

  function setSomething(newInputValues, setWhat){
    appInfo[setWhat] = newInputValues;
    setAppInfo(appInfo);
  }

  function setInputValues(newInputValues){
    return setSomething(newInputValues, 'inputValues');
  }

  function setAlertVisibility(newInputValues){
    return setSomething(newInputValues, 'alertVisibility');
  }

  const { openConnectModal } = useConnectModal();
  const { openChainModal } = useChainModal();
  const { address, isConnected } = useAccount();
  const { chain } = useNetwork();
  var chainId = 0;
  if (chain){
    chainId = chain.id;
  }

  var actChainId = CoreFns.relevantChainId(currentList);
  function initSim(){
    if (isConnected){
      if (chainId === actChainId){
        disconnect();
      }else{
        openChainModal();
      }
    }else{
      openConnectModal();
    }
    setChainInfo({});
  }

  var addressOut = '';
  if (isConnected){
    addressOut = address;
  }

  var inputValues;
  var alertVisibility;
  var urlParamsForExecution;
  var interactionFn;
  var internalVariables;

  if (appInfo){
    internalVariables = appInfo.internalVariables;
    internalVariables.publicClient = publicClient;
    internalVariables['isConnected'] = isConnected;
    internalVariables['activeUser'] = addressOut;
    internalVariables['chainId'] = chainId
    internalVariables['chainInfo'] = chainInfo;
    internalVariables['setChainInfo'] = setChainInfo;
    internalVariables['otherInfo'] = otherInfo;
    internalVariables['setOtherInfo'] = setOtherInfo;
    internalVariables['currentScreen'] = {t:'fe', v:currentPreviewFE};

    inputValues = appInfo.inputValues;
    alertVisibility = appInfo.alertVisibility;
    urlParamsForExecution = appInfo.urlParamsForExecution;


    interactionFn = InteractionFns.doInteractionFn(chains, currentList, internalVariables, width, height, inputValues, setInputValues, ownVariables, setOwnVariables, musicStatus, setMusicStatus, alertVisibility, setAlertVisibility, urlParamsForExecution, urlHeader, initSim, currentPreviewFE, setPreviewFE, screenRefs, popUps, setPopUps, programSetID, setAppInfo, setChainInfo);
  }

  useEffect(()=>{
    var aPossib = 'load';
    var ocSet = currentList.oc;
    if (ocSet && run){
      interactionFn(false, ocSet, aPossib, [], ['oc', aPossib]);
    }

  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <ShowAScreen chains={chains} overallWidth={overallWidth} internalVariables={internalVariables} width={width} height={height} currentList={currentList} inputValues={inputValues} setInputValues={setInputValues} alertVisibility={alertVisibility} interactionFn={interactionFn} overlays={overlays} whichFEOrPU={{t:'fe', v:currentPreviewFE}} screenRefs={screenRefs} setScreenRefs={setScreenRefs} popUps={popUps} setPopUps={setPopUps} ownVariables={ownVariables} urlParamsForExecution={urlParamsForExecution} urlHeader={urlHeader} offsetLeft={offsetLeft} offsetTop={offsetTop} musicStatus={musicStatus} />        

}


export default App;
